import { pictogramsData } from '@app/components/metric-table-value-build';
import Icon from '@app/components/ui/icons';
import { QmAppealStatuses } from '@app/interfaces/qm-module/qm-appellations/qm-appellations.type';
import {
  CriteriaHistoryObjectType,
  ManualAndAutoFilledCriteriaObjectType,
} from '@app/interfaces/qm-module/qm-manage/qm-monioring-tasks.type';
import React, { FC, ReactNode } from 'react';

import { colorsForAppealBorder } from './appeal-status-for-record';

const HistoryComponent: FC<{
  history: CriteriaHistoryObjectType[];
  comments?: boolean;
  className?: string;
  status?: QmAppealStatuses | undefined;
  historyComments?: ManualAndAutoFilledCriteriaObjectType['comments'];
}> = (props) => {
  const { history, comments, historyComments, className, status } = props;

  const markupByCommentType = (
    history: CriteriaHistoryObjectType,
  ): Record<ManualAndAutoFilledCriteriaObjectType['comments']['type'], ReactNode> => {
    const findOption = historyComments?.settings?.select.find(({ id }) => id === history.value);

    return {
      INPUT: <span>{history.value}</span>,
      SELECT: (
        <div className="flex items-center">
          {historyComments?.settings?.display_type === 'ICON' ? (
            <Icon
              key={findOption?.color}
              size={18}
              className={`${!findOption?.color && 'text-action'}`}
              customStyle={{ color: findOption?.color ? findOption.color : '' }}
              name={pictogramsData[findOption?.icon || 0]}
            />
          ) : historyComments?.settings?.display_type === 'VALUE_ICON' ? (
            <div className="flex items-center gap-[10px]">
              <span>{findOption?.desc}</span>
              <Icon
                key={findOption?.color}
                size={18}
                className={`${!findOption?.color && 'text-action'}`}
                customStyle={{ color: findOption?.color ? findOption.color : '' }}
                name={pictogramsData[findOption?.icon || 0]}
              />
            </div>
          ) : (
            <span>{findOption?.desc}</span>
          )}
        </div>
      ),
    };
  };

  return (
    <div className={`w-full flex flex-col gap-[10px] overflow-y-auto ${className}`}>
      {history.map((history, index) => (
        <div
          style={{
            borderColor:
              status === 'ACCEPTED'
                ? colorsForAppealBorder[1]
                : status === 'DECLINED' || status === 'CLOSED'
                ? colorsForAppealBorder[2]
                : colorsForAppealBorder[0],
          }}
          key={history.dt + history.who.id + index}
          className={`${
            false && 'border'
          } p-2 relative rounded-defaultR hover:bg-3color/10 flex flex-col gap-[5px]`}
        >
          <div className="flex items-center gap-[10px]">
            <div className="w-[24px] h-[24px] flex items-center justify-center rounded-full bg-3color">
              <Icon name="UserIcon" size={10} className="text-white" />
            </div>
            <div className="text-[14px] text-3color">{history.who.name || 'N/A'}</div>
            <div className="text-[10px] self-start text-3color">{history.who.type}</div>
          </div>
          <div className="text-[14px] text-3color p-2 rounded-defaultR bg-3color/20">
            {comments ? (
              historyComments?.type && markupByCommentType(history)[historyComments?.type]
            ) : (
              <div>
                <span>
                  {String(history.value_before)} {'----->'} {history.value_set}
                </span>
              </div>
            )}
          </div>
          <div className="text-[9px] text-3color">
            <span>{history.dt}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
export default HistoryComponent;
